import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'noBlankSpaces'
})
export class NoBlankSpacesPipe implements PipeTransform {

  transform(value: string, ...args: string[]): string {
    return value.split(" ")[0];
  }

}
